import Configs from "../../vendorConfigs/Configs";
import { IRequestBuilder } from "../../../core/src/server/requests/RequestBuilder";
import GameModel from "../../../core/src/model/GameModel";
import ConsoleUtil from "../../../core/src/utils/ConsoleUtil";


export default class VendorReplayRequest implements IRequestBuilder {
    // gameReplayServiceURL
    get method() {
      return "GET";
    }
  
    get path() {
      return Configs.game.clientConfig.replayApi;
    }
  
    get requestData() {
      let data = {
        replaytoken: GameModel.replayToken,
        gameid: Configs.vendorServer.gameId,
        lang: GameModel.lang
      };
  
      ConsoleUtil.log("[Requests] ReplayRequest", data);
  
      return data;
    }
  }